export const SHELL = {
  EMPTY: 'shell.empty',
  ERROR: 'shell.error',
  ERROR_RETRY: 'shell.error.retry',
  HEADER: 'shell.header',
  NAV_HOME: 'shell.nav.home',
  ROOT: 'shell.root',
  SIDEBAR: 'shell.sidebar',
} as const;
